exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.spinner {\n    text-align: center;\n}\n.spinner .clip {\n    display: inline-block;\n    animation: clipDelay 750ms 0s infinite linear;\n    animation-fill-mode: both;\n}\n@keyframes clipDelay {\n0% {\n        transform: rotate(0deg) scale(1);\n}\n50% {\n        transform: rotate(180deg) scale(0.8);\n}\n100% {\n        transform: rotate(360deg) scale(1);\n}\n}\n", ""]);

// exports
